import {useState} from 'react';
import {Select} from 'antd';
import {useLazyQuery} from '@apollo/client';
import {GET_CUSTOMERS_PAGINATED} from '../../admin/clients/queryClientsGQL';

let timeout = null;
let currentValue = '';

export const RemoteSearchClients = ({onSelectClient}) => {
  console.log("🚀 ~ RemoteSearchClients ~ onSelectClient:", onSelectClient)
  const [options, setOptions] = useState([]);
  const [value, setValue] = useState(null);

  const [fetchCustomers, {loading}] = useLazyQuery(GET_CUSTOMERS_PAGINATED, {
    fetchPolicy: 'network-only'
  });

  const fetchData = (searchTextRaw) => {
    const searchText = searchTextRaw?.trim().toLowerCase();

    if (timeout) clearTimeout(timeout);
    currentValue = searchText;

    const run = async () => {
      if (!searchText) {
        setOptions([]);
        return;
      }

      const {data} = await fetchCustomers({
        variables: {limit: 200, offset: 0, searchString: searchText}
      });
      
      const customers = data?.customersPaginated?.customers ?? [];

      if (currentValue === searchText) {
        setOptions(
          customers.map((c) => ({
            value: c.clie_id,
            label: `${c.clie_rfc} - ${c.clie_nombre} ${c.clie_ap} ${c.clie_am}`,
            raw: c // 👈 guardamos el objeto entero
          }))
        );
      }
    };

    timeout = setTimeout(run, 300);
  };

  const handleChange = (selectedId) => {
    setValue(selectedId);

    const selectedOption = options.find((o) => o.value === selectedId);
    onSelectClient?.(selectedOption?.raw || null);
  };

  return (
    <Select
      showSearch
      filterOption={false}
      onSearch={fetchData}
      placeholder="Todos los clientes"
      style={{width: '100%'}}
      value={value}
      loading={loading}
      onChange={handleChange}
      allowClear
      notFoundContent={loading ? 'Cargando...' : 'Escribe para buscar clientes'}
      options={options}
    />
  );
};
